module.exports = __webpack_public_path__ + "static/media/click-treebank.fcd98c95.png";